// Angular
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Sanitize HTML
 */
@Pipe({
  name: 'safeHTML'
})
export class SafeHTMLPipe implements PipeTransform {
  /**
   * Pipe Constructor
   *
   * @param _sanitizer: DomSanitezer
   */
  // tslint:disable-next-line
  constructor(protected _sanitizer: DomSanitizer) {
  }

  
  /**
   * Transform
   *
   * @param value: string
   * @param type: string
   */
  transform(value: string, type?: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl | string | null {
    if(type) {
      switch (type) {
        case 'special':
          return this._sanitizer.sanitize(SecurityContext.HTML, this._sanitizer.bypassSecurityTrustHtml(value))
        case 'html':
          return this._sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this._sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this._sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this._sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this._sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          return this._sanitizer.bypassSecurityTrustHtml(value);
      }
    } else {
      return this._sanitizer.bypassSecurityTrustHtml(value);
    }

  }
}

